/**
 * 升级公告维护编辑页面
 * 创建时间：2017-07-10
 * 创建人：baixx
 */
<template>
	<div id="versionhistoryedit" class="float-e-margins ibox-content ibox_main" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">版本时间</label>
				<input type="text" v-model="queryParam.versionDate" style='display:none;'>
				<div class="col-sm-3">
					<datepicker v-model="queryParam.versionDate" :value="queryParam.versionDate" class="form-control" ref="versionFrom"></datepicker>
				</div>
				<label class="col-sm-1 control-label">版本名称</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="queryParam.versionName">
				</div>
				<label class="col-sm-1 control-label">系统平台</label>
				<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.systemTypes">
							<option v-for="systemType in systemTypeList" :value="systemType.udccode">{{systemType.udcname}}</option>
						</select>
				</div>
			</div>
			<div class="form-group">
			    <div class="col-sm-12 text-right">
			    	<button class="btn btn-primary" @click="resetQueryParams">重置</button>
				</div>
			</div>	
			<div class="form-group">
				<label class="col-sm-1 control-label">版本内容</label>
			</div>
			<textarea id="applicationform" class="ckeditor" name="applicationform" rows="30" cols="20" ></textarea>
			<br>
			<div class="form-group">
				<div  class="col-sm-12 text-center">
					<a class="btn btn-primary white" @click="finishedProcessed">保存</a>
				</div>
			</div>
		</div>
		<sub-modal ref="modalMsg" size="small" title="提示">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</sub-modal>
	</div>	
</template>
 
<script>
    import Datepicker from 'components/common/datepicker/Datepicker'
    import SubModal from 'components/common/SubModal'
    import { OPERATE_EXCEPTION } from 'static/message'
    import {getDictionaryFromArray} from 'util/util'
    import {DICTIONARY_MAP} from 'static/constant'
	export default{
		name: "PageVersionHistoryEdit",
		components: {
			Datepicker,
			SubModal,
		},
		props: ['data','model','udccode'],
		data() {
			return {
				loadingstatus:false,
				tipContent:"",
				queryParam:{
					versionDate: "",                         // 版本时间
					versionName: "",						// 系统
					content: ""	,						    // 版本内容
					systemTypes:""                        //系统平台类型分组
				},
			    systemTypeList:[]                                      //系统平台类型下拉列表
			};
			
		},
		beforeMount(){
			//获取数据字典
			this.getUdc();
		},
		
		watch: {
			model() {
				CKEDITOR.instances.applicationform.setData(this.data.content);
			},
			data(){
				this.queryParam = this.data;
			},
			udccode(val){
				this.queryParam.systemTypes = this.udccode;
			}
		},
		created() { 
			this.$nextTick(function(){
				this.getContent();
			});
        }, 
		methods: {
			getContent(){
				const { loadAsyncScript } = this;
				    loadAsyncScript("http://cdn.ckeditor.com/4.7.1/standard/ckeditor.js",()=>{CKEDITOR.replace('applicationform');});
			},
			loadAsyncScript(src, callback) {
				var srcArray = src.split("?")[0].split("/");
				var scr_src = srcArray[srcArray.length - 1];
				// 判断要 添加的脚本是否存在如果存在则不继续添加了  
				var scripts = document.getElementsByTagName("script");
				if(!!scripts && 0 != scripts.length) {
					for(var i = 0; i < scripts.length; i++) {
						if(-1 != scripts[i].src.indexOf(scr_src)) {
							callback();
							return true;
						}
					}
				}
				// 不存在需要的则添加  
				var head = document.getElementsByTagName("head")[0];
				var script = document.createElement("script");
				script.setAttribute("type", "text/javascript");
				script.setAttribute("src", src);
				script.setAttribute("async", true);
				script.setAttribute("defer", true);
				head.appendChild(script);
				if(document.all) {
					script.onreadystatechange = function() {
						var state = this.readyState;
						if(state === 'loaded' || state === 'complete') {
							callback();
						}
					}
				} else {
					//firefox, chrome  
					script.onload = function() {
						callback();
					}
				}
			},
			// 保存
			finishedProcessed(){
				if(!this.queryParam.versionDate ||!this.queryParam.versionName ||!CKEDITOR.instances.applicationform.getData()){
						this.openMsgTip("版本名称或内容不能为空");
						return;
					}
				//公告新建
				if(this.model == "0"){
					const para = {
						sysSource:this.queryParam.systemTypes,								                       // 系统
						versionDate:this.queryParam.versionDate,			                       // 版本时间
						versionName:this.queryParam.versionName,                                 // 版本名称
						versionContent:CKEDITOR.instances.applicationform.getData(),       //版本说明
				    }
					this.loadingstatus = true;
					this.$http.post(process.env.API_ROOT + '/version/versions',para)
					.then( res => {
						if(res.body.success){
							this.$emit('handleSave');
							this.loadingstatus = false;
						} else {
							this.openMsgTip(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openMsgTip(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openMsgTip(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
				}
				//公告编辑
				if(this.model == "1"){
					const para = {
						sysSource: this.queryParam.systemTypes,								             // 系统
						versionDate:this.queryParam.versionDate,			                             // 版本时间
						versionName:this.queryParam.versionName,                                       // 版本名称
						versionContent:CKEDITOR.instances.applicationform.getData(),             //版本说明
					}
					this.loadingstatus = true;
					this.$http.put(process.env.API_ROOT + '/version/versions/'+this.data.id,para)
					.then( res => {
						if(res.body.success){
							this.$emit('handleSave');
							this.loadingstatus = false;
						} else {         
							this.openMsgTip(res.body.message);
							this.loadingstatus = false;
						}
					}, res => {
						this.openMsgTip(res.body.message);
						this.loadingstatus = false;
					}).catch( res => {
						this.openMsgTip(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
				}
			},
			openMsgTip(message) {
				this.tipContent = message
				this.$refs.modalMsg.open();	
			},
			closeMsgTip() {    
				this.$refs.modalMsg.close();	
			},
			// 获取数据字典
        	getUdc(){
        		let udcType = [
					 DICTIONARY_MAP.SYSTEM_TYPE,  
				]
				let param = udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.body.success){		
					 	this.systemTypeList = getDictionaryFromArray(res.body.data, DICTIONARY_MAP.SYSTEM_TYPE);
					}else{
						//this.openModalMsg(res.data.message);
					}
				}, res => {
					//this.openModalMsg(res.data.message);
				}).catch( res => {
					//this.openModalMsg(OPERATE_EXCEPTION);
				})	
        	},	
			//重置
    		resetQueryParams:function(){
				this.$refs.versionFrom.handleClear();
				CKEDITOR.instances.applicationform.setData('');
				this.queryParam = {
					versionDate: "",                         // 版本时间
					versionName: "",						// 版本名称
					content: "",						    // 版本内容
				}
		    }
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageVersionHistoryEdit.vue?66bc479a